import { render, staticRenderFns } from "./PlusTvSquareCard.vue?vue&type=template&id=348c6038&scoped=true"
import script from "./PlusTvSquareCard.vue?vue&type=script&lang=js"
export * from "./PlusTvSquareCard.vue?vue&type=script&lang=js"
import style0 from "./PlusTvSquareCard.vue?vue&type=style&index=0&id=348c6038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c6038",
  null
  
)

export default component.exports